module.exports = __webpack_public_path__ + "static/media/marketing-mix-modeling-hero.45b7c5aa.png";